import { render, staticRenderFns } from "./AttoreTabs.vue?vue&type=template&id=18958dd8&scoped=true&"
import script from "./AttoreTabs.vue?vue&type=script&lang=ts&"
export * from "./AttoreTabs.vue?vue&type=script&lang=ts&"
import style0 from "./AttoreTabs.vue?vue&type=style&index=0&id=18958dd8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18958dd8",
  null
  
)

export default component.exports